import monitoringsTaskTripsService from "../shared/services/logisticMonitoringsTaskTripsService";

const REQUEST_MONITORING_TASK_TRIPS = "REQUEST_MONITORING_TASK_TRIPS";
const RESPONSE_MONITORING_TASK_TRIPS = "RESPONSE_MONITORING_TASK_TRIPS";
const REQUEST_MONITORING_TASK_TRIPS_FAILURE = "REQUEST_MONITORING_TASK_TRIPS_FAILURE";

const requestMonigtoringTaskTripsAction = () => {
  return {
    type: REQUEST_MONITORING_TASK_TRIPS,
  };
};

const responseMonigtoringTaskTripsAction = (data) => {
  return {
    type: RESPONSE_MONITORING_TASK_TRIPS,
    data,
  };
};

const requestMonigtoringTaskTripsFailureAction = (errors) => {
  return {
    type: REQUEST_MONITORING_TASK_TRIPS_FAILURE,
    errors,
  };
};

const getMonitoringsTaskTrips = (options) => {
  return (dispatch) => {
    dispatch(requestMonigtoringTaskTripsAction());

    monitoringsTaskTripsService
      .getLogisticMonitoringsTaskTrips(options)
      .then((result) => {
        dispatch(responseMonigtoringTaskTripsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMonigtoringTaskTripsFailureAction(error.response));
      });
  };
};

const ON_SET_SEARCH_MONITORING_TASK_TRIPS = "ON_SET_SEARCH_MONITORING_TASK_TRIPS";

const setSearchTearmMonitoringTaskTripsAction = (data) => {
  return {
    type: ON_SET_SEARCH_MONITORING_TASK_TRIPS,
    data,
  };
};

const setSeatchTerm = (data) => {
  return (dispatch) => {
    dispatch(setSearchTearmMonitoringTaskTripsAction(data));
  };
};

const REQUEST_MONITORING_TASK_TRIP = "REQUEST_MONITORING_TASK_TRIP";
const RESPONSE_MONITORING_TASK_TRIP = "RESPONSE_MONITORING_TASK_TRIP";
const REQUEST_MONITORING_TASK_TRIP_FAILURE = "REQUEST_MONITORING_TASK_TRIP_FAILURE";

const requestMonigtoringTaskTripAction = () => {
  return {
    type: REQUEST_MONITORING_TASK_TRIP,
  };
};

const responseMonigtoringTaskTripAction = (data) => {
  return {
    type: RESPONSE_MONITORING_TASK_TRIP,
    data,
  };
};

const requestMonigtoringTaskTripFailureAction = (errors) => {
  return {
    type: REQUEST_MONITORING_TASK_TRIP_FAILURE,
    errors,
  };
};

const getMonitoringsTaskTrip = (options) => {
  return (dispatch) => {
    dispatch(requestMonigtoringTaskTripAction());

    if (options === null) {
      dispatch(responseMonigtoringTaskTripAction(null));

      return;
    }

    monitoringsTaskTripsService
      .getLogisticMonitoringsTaskTrip({ id: options.id, timeZone: (new Date().getTimezoneOffset() / 60) * -1 })
      .then((result) => {
        dispatch(responseMonigtoringTaskTripAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMonigtoringTaskTripFailureAction(error.response));
      });
  };
};

const REQUEST_COMPLETED_MONITORING_TASK_TRIP = "REQUEST_COMPLETED_MONITORING_TASK_TRIP";
const RESPONSE_COMPLETED_MONITORING_TASK_TRIP = "RESPONSE_COMPLETED_MONITORING_TASK_TRIP";
const REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE = "REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE";

const requestCompletedMonigtoringTaskTripAction = () => {
  return {
    type: REQUEST_COMPLETED_MONITORING_TASK_TRIP,
  };
};

const responseCompletedMonigtoringTaskTripAction = (data) => {
  return {
    type: RESPONSE_COMPLETED_MONITORING_TASK_TRIP,
    data,
  };
};

const requestCompletedMonigtoringTaskTripFailureAction = (errors) => {
  return {
    type: REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE,
    errors,
  };
};

const completedMonitoringsTaskTrip = (options) => {
  return (dispatch) => {
    dispatch(requestCompletedMonigtoringTaskTripAction());

    monitoringsTaskTripsService
      .completedLogisticTaskTrip({ id: options.id })
      .then((result) => {
        dispatch(responseCompletedMonigtoringTaskTripAction(options));
      })
      .catch((error) => {
        dispatch(requestCompletedMonigtoringTaskTripFailureAction(error.response));
      });
  };
};

const SET_MONITORING_SETTINGS_STATE = "SET_MONITORING_SETTINGS_STATE";

const rsetMonitoringSettingsStateAction = (data) => {
  return {
    type: SET_MONITORING_SETTINGS_STATE,
    data,
  };
};

const setMonitoringSettingsState = (data) => {
  return (dispatch) => {
    dispatch(rsetMonitoringSettingsStateAction(data));
  };
};

const REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS = "REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS";
const RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS = "RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS";
const REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE = "REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE";

const requestAddUnitToTaskTripAction = () => {
  return {
    type: REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS,
  };
};

const responseAddUnitToTaskTripAction = (data) => {
  return {
    type: RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS,
    data,
  };
};

const requestAddUnitToTaskTripFailureAction = (errors) => {
  return {
    type: REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE,
    errors,
  };
};

const addUnitToTaskTrip = (options) => {
  return (dispatch) => {
    dispatch(requestAddUnitToTaskTripAction());

    monitoringsTaskTripsService
      .addUnitLogisticTaskTrip({
        id: options.id,
        routeId: options.routeId,
        unitId: options.unitId,
        controlPointId: options.controlPointId,
      })
      .then((result) => {
        dispatch(responseAddUnitToTaskTripAction({ ...options, routes: [] }));
      })
      .catch((error) => {
        dispatch(requestAddUnitToTaskTripFailureAction(error.response));
      });
  };
};

const REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS = "REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS";
const RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS = "RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS";
const REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE = "REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE";

const requestAddRoutesToTaskTripAction = () => {
  return {
    type: REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS,
  };
};

const responseAddRoutesToTaskTripAction = (data) => {
  return {
    type: RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS,
    data,
  };
};

const requestAddRoutesToTaskTripFailureAction = (errors) => {
  return {
    type: REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE,
    errors,
  };
};

const addRoutesToTaskTrip = (options) => {
  return (dispatch) => {
    dispatch(requestAddRoutesToTaskTripAction());

    monitoringsTaskTripsService
      .addRoutesLogisticTaskTrip({
        id: options.id,
        unitId: options.unitId,
        routes: options.routes.map((x) => {
          return x.id;
        }),
      })
      .then((result) => {
        dispatch(responseAddRoutesToTaskTripAction({ ...options, routeId: null, controlPointId: null }));
      })
      .catch((error) => {
        dispatch(requestAddRoutesToTaskTripFailureAction(error.response));
      });
  };
};

export {
  REQUEST_MONITORING_TASK_TRIPS,
  RESPONSE_MONITORING_TASK_TRIPS,
  REQUEST_MONITORING_TASK_TRIPS_FAILURE,
  getMonitoringsTaskTrips,
  ON_SET_SEARCH_MONITORING_TASK_TRIPS,
  setSeatchTerm,
  REQUEST_MONITORING_TASK_TRIP,
  RESPONSE_MONITORING_TASK_TRIP,
  REQUEST_MONITORING_TASK_TRIP_FAILURE,
  getMonitoringsTaskTrip,
  REQUEST_COMPLETED_MONITORING_TASK_TRIP,
  RESPONSE_COMPLETED_MONITORING_TASK_TRIP,
  REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE,
  completedMonitoringsTaskTrip,
  SET_MONITORING_SETTINGS_STATE,
  setMonitoringSettingsState,
  REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS,
  RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS,
  REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE,
  addUnitToTaskTrip,
  REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS,
  RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS,
  REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE,
  addRoutesToTaskTrip,
};
